import request from "../../../utils/request";

export const getFinanceWriteOffList = '/finance/writeOff/getWriteOffList';

export const getWriteOffOrders = '/finance/writeOff/getWriteOffOrders'

export function doWriteOff(values: any) {
    return request.request({
        url: '/finance/writeOff/',
        method: "post",
        data: values
    })
}

export function editWriteOff(values: any) {
    return request.request({
        url: '/finance/writeOff/',
        method: "put",
        data: values
    })

}

export function deleteWriteOff(writeOffId: number) {
    return request.request({
        url: '/finance/writeOff/',
        method: "delete",
        params: {writeOffId: writeOffId}
    })
}

export function approveWriteOff(writeOffId: number, force: boolean = false) {
    return request.request({
        url: '/finance/writeOff/approve',
        method: "get",
        params: {writeOffId: writeOffId, force: force}
    })
}

export function getWriteOffDetail(writeOffId: number) {
    return request.request({
        url: '/finance/writeOff/detail',
        method: 'get',
        params: {writeOffId: writeOffId}
    })
}

